import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'newlineToBr',
    standalone: true
})
export class NewlineToBrPipe implements PipeTransform {

  transform(value: string) {
    return value && value.replace(/(?:\r\n|\r|\n)/g, '<br />') || '';
  }

}
